import Phaser from 'phaser';
import { GAME_HEIGHT, GAME_WIDTH } from './core/Config';
import { BootScene } from './scenes/BootScene';
import { HouseScene } from './scenes/HouseScene';
import { UIScene } from './scenes/UIScene';
import { VillageScene } from './scenes/VillageScene';

export function createGame(parent: string) {
  return new Phaser.Game({
    type: Phaser.AUTO,
    parent,
    width: GAME_WIDTH,
    height: GAME_HEIGHT,
    backgroundColor: '#0b1020',
    pixelArt: true,
    antialias: false,
    roundPixels: true,
    scale: {
      mode: Phaser.Scale.FIT,
      autoCenter: Phaser.Scale.CENTER_BOTH,
      width: GAME_WIDTH,
      height: GAME_HEIGHT,
    },
    physics: {
      default: 'arcade',
      arcade: {
        debug: false,
      },
    },
    scene: [BootScene, VillageScene, HouseScene, UIScene],
  });
}
